import React from "react"
import SignInContext from "accounts/contexts/SignIn"
import useSignIn from "accounts/contexts/SignIn/useSignIn"

interface ProviderProps {
  children: React.ReactNode
}

const SignInProvider = ({ children }: ProviderProps) => {
  const data = useSignIn()

  return (
    <SignInContext.Provider value={data}>{children}</SignInContext.Provider>
  )
}

export default SignInProvider
